import {
  FiType,
  FiBold,
  FiItalic,
  FiUnderline,
  FiSlash,
  FiAlignLeft,
  FiAlignCenter,
  FiAlignRight,
  FiAlignJustify,
  FiList,
  FiLink,
  FiImage,
  FiCode,
} from "react-icons/fi";
import { TfiListOl } from "react-icons/tfi";

/* one‑liner cast, exactly like your UpIcon example */
export const TypeIcon = FiType as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const BoldIcon = FiBold as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const ItalicIcon = FiItalic as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const UnderlineIcon = FiUnderline as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const StrikeIcon = FiSlash as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const AlignLeftIcon = FiAlignLeft as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const AlignCenterIcon = FiAlignCenter as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const AlignRightIcon = FiAlignRight as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const AlignJustIcon = FiAlignJustify as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const ListOlIcon = TfiListOl as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const ListUlIcon = FiList as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const LinkIcon = FiLink as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const ImageIcon = FiImage as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const CodeIcon = FiCode as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
